// The password rule the three password forms (SignupScreen, ResetPasswordScreen, ProfileScreen)
// give their inputs as `pattern`, and that the API enforces too (backend/routes/userRoutes.js,
// whose test checks that the two copies agree): 8 to 128 characters with a letter, a digit and
// a special character, and no whitespace. The browser compiles a pattern with the `v` flag, so
// the characters are code points, which the backend's `u` flag matches.
export const PASSWORD_PATTERN =
  '^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\\W_])(?!.*\\s).{8,128}$';
